import { Icon } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { COMPONENT_STATUS_STYLES } from "@/components/pages_logged_in/program/components/constants";
import { isCloseEarlyComponent } from "@/components/pages_logged_in/program/components/utils";
import { SUBTEXT_COLOR } from "@/css/constants";
import {
  ComponentStatus,
  ComponentTypeEnum,
  GetParticipantSessionResponseQuery,
} from "@/graphql";
import {
  LeadComponent,
  MainComponent,
  ParticipantComponent,
} from "@/types/programs";
import { NonNullableArrayItem } from "@/utils/types";

type ResponseComponentType = NonNullableArrayItem<
  NonNullable<
    GetParticipantSessionResponseQuery["participantSessionResponse"]
  >["programComponents"]
>;

type BaseProgramComponent =
  | LeadComponent
  | MainComponent
  | ParticipantComponent;

type ProgramComponent = BaseProgramComponent | ResponseComponentType;

interface ProgramComponentStatusProps {
  component: ProgramComponent;
}

export function ProgramComponentStatus({
  component,
}: ProgramComponentStatusProps) {
  const isCloseEarly = isCloseEarlyComponent(component);

  const componentStatus = component.status;

  const statusConfig = COMPONENT_STATUS_STYLES[componentStatus];
  let icon = statusConfig?.icon;
  let color = statusConfig?.color;

  if (
    isCloseEarly &&
    [
      ComponentStatus.NoResponse,
      ComponentStatus.DidNotFinish,
      ComponentStatus.DidNotPass,
    ].includes(componentStatus)
  ) {
    color = SUBTEXT_COLOR;
    icon = <Icon className="text-subtext text-sm" icon="cross-circle" />;
  }

  if (component.type === ComponentTypeEnum.Announcement) return null;

  return (
    <Flex alignItems="center">
      {icon}
      <Box className="xs:text-sm font-normal md:text-base" color={color} ml={2}>
        {statusConfig?.text}
      </Box>
    </Flex>
  );
}
